/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { renderComponent } from '@trello/component-wrapper';
import { sendErrorEvent } from '@trello/error-reporting';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import ReactDOM from '@trello/react-dom-wrapper';

import { LazyTeamOnboardingPupPopover } from 'app/src/components/BusinessClassTeamOnboardingPupPopover';
import type { BoardView } from './BoardView';

export const unmountTeamOnboardingPupPopover = function (this: BoardView) {
  if (this.teamOnboardingPupPopoverDiv != null) {
    return ReactDOM.unmountComponentAtNode(this.teamOnboardingPupPopoverDiv);
  }
};

export const renderTeamOnboardingPupPopover = function (this: BoardView) {
  try {
    const workspace = this.model.getOrganization();

    if (workspace == null) {
      return;
    }

    if (this.teamOnboardingPupPopoverDiv == null) {
      const targetDiv = this.el.querySelector(
        '#team-onboarding-pup-popover-target',
      ) as HTMLDivElement;

      if (targetDiv != null) {
        this.teamOnboardingPupPopoverDiv = targetDiv;
      } else {
        $('.board-main-content', this.$el).append(
          "<div id='team-onboarding-pup-popover-target'></div>",
        );
        this.teamOnboardingPupPopoverDiv = this.el.querySelector(
          '#team-onboarding-pup-popover-target',
        );
      }
    }

    const boardId = this.model.get('id');

    return renderComponent(
      <LazyTeamOnboardingPupPopover
        workspaceId={workspace.id}
        boardId={boardId}
        // eslint-disable-next-line react/jsx-no-bind
        onShowPowerUps={() => this.toggleDirectory()}
      />,
      this.teamOnboardingPupPopoverDiv,
    );
  } catch (err) {
    sendErrorEvent(err, {
      tags: {
        ownershipArea: 'trello-mocha',
        feature: 'Team Onboarding',
      },
      extraData: {
        component: 'board-view-team-onboarding-pups',
      },
    });
  }
};
